<template>
    <div class="search-group template2">
        <div class="tab-header">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.name"
            ></span>
        </div>
        <div class="tab-header mobile">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.mobileModelName"
            ></span>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :submitText="item.submitText"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :autoSubmit="true"
                />
                <address-input
                    v-else-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    icon="icon-search-medium"
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    @submitAddress="
                        (address, data, callback) =>
                            submitAddress(
                                { address, data, callback },
                                index,
                                item.submitType,
                                item.submitUrl
                            )
                    "
                />
            </div>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener noreferrer"
            >{{ agreementData.agreement }}</a
            >
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    components: {
        AddressInput
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.template2 {
    width: 1080px;
    margin: 0 auto;
    max-width: 100%;
    padding: 40px;
    border-radius: 4px;
    box-shadow: 0 0 13px 0 rgba(32, 36, 55, 0.2);
    background-color: white;
    @include media-min-1080 {
        &.row {
            // width: 50%;
            max-width: 480px;
            position: relative;
            padding: 30px;
            .tab-header {
                .item {
                    height: 36px;
                    line-height: 36px;
                    padding: 0 10px;
                    font-size: 14px;
                    margin-right: 10px;
                    white-space: nowrap;
                }
            }
            .tab-body {
                .tab-content {
                    .search-bar {
                        .keyword-submit {
                            display: none;
                        }
                        > .keyword-submit {
                            @include color-button-hover();
                            display: flex;
                            height: 50px;
                            width: 100%;
                            margin-top: 38px;
                            @include color-button();
                        }
                        .search-by-section {
                            .search-category {
                                .search-input {
                                    width: 100%;
                                    height: 40px;
                                    padding-left: 20px;
                                    font-size: 14px;
                                    line-height: 14px;
                                    color: #515666;
                                    outline: none;
                                    box-shadow: none;
                                    text-overflow: ellipsis;
                                    -webkit-appearance: none;
                                    border-radius: 4px;
                                    border: solid 1px #e1e2e6;
                                    background-color: #fcfcfc;
                                }
                            }
                        }
                    }
                    .address-input {
                        flex-wrap: wrap;
                        height: auto;
                        .left-box {
                            width: 100%;
                            .input {
                                height: 40px;
                                border-radius: 4px;
                                border: solid 1px #e1e2e6;
                                background-color: #fcfcfc;
                            }
                        }
                        .right-box {
                            width: 100%;
                            margin-top: 38px;
                            .submit-btn {
                                width: 100%;
                                height: 50px;
                                line-height: 50px;
                                text-align: center;
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }
        }
    }

    .tab-header {
        display: flex;
        width: 100%;
        &.mobile {
            display: none;
        }

        .item {
            position: relative;
            margin-right: 30px;
            height: 48px;
            border-radius: 4px;
            line-height: 48px;
            padding: 0 15px;
            font-family: var(--font-medium);
            font-size: 16px;
            color: #202437;
            cursor: pointer;

            &.active {
                @include color-button();
            }
            &:hover {
                @include color-button();
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .tab-body {
        width: 100%;
        margin-top: 30px;
        // margin-bottom: 25px;
        .tab-content {
            width: 100%;
            display: none;

            &.active {
                display: block;

                .address-input {
                    width: 100%;
                }
            }

            .search-bar {
                margin-top: 0;
                @include media-800 {
                    padding: 0 15px;
                }
                .keyword-submit {
                    width: 140px;
                }
            }
            .address-input {
                height: 56px;
                .left-box {
                    .input {
                        height: 56px;
                        border-radius: 4px 0 0 4px;
                        @include color-theme('border', 1px solid);
                        border-right: none;
                        background-color: #fcfcfc;
                    }
                }
                .right-box {
                    .submit-btn {
                        @include color-button-hover();
                        width: 140px;
                        padding: 0 10px;
                        font-size: 16px;
                        border-radius: 0 4px 4px 0;
                        height: 56px;
                        line-height: 56px;
                        @include color-button();
                        .iconfont {
                            margin-right: 5px;
                            font-size: 20px;
                        }
                    }
                }
            }
            > * {
                padding: 0;
                box-shadow: none;
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #000000;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #000000;
                }
            }
        }
    }
    @include media-800 {
        border-radius: 0;
        box-shadow: none;
        padding: 20px 10px 0;

        .tab-header {
            display: none;
            &.mobile {
                display: flex;
                height: 35px;
                justify-content: center;
                .item {
                    line-height: 35px;
                    height: 35px;
                    color: var(--mg-button-background);
                    text-align: center;
                    &:not(:last-child) {
                        margin-right: 20px;
                    }
                    &.active {
                        color: white;
                    }
                }
            }
        }

        .tab-body {
            .tab-content {
                height: 46px;
                .search-bar {
                    .search-by-section {
                        border-bottom: none;
                        .search-category {
                            border: none;
                            .keyword {
                                .search-input {
                                    height: 46px;
                                    padding-left: 10px;
                                    border-radius: 2px 0 0 2px;
                                    border: 1px solid #e1e2e6;
                                    border-right: none;
                                }
                            }
                            .keyword-submit {
                                display: none;
                            }
                        }
                    }
                    > .keyword-submit {
                        height: 46px;
                        line-height: 46px;
                        border-radius: 0 2px 2px 0;
                    }
                }

                .address-input {
                    box-shadow: none;
                    height: 46px;
                    .left-box {
                        height: 100%;
                        .iconfont {
                            display: none;
                        }
                        .input {
                            height: 100%;
                            padding-left: 10px;
                            border-radius: 2px 0 0 2px;
                            border: 1px solid rgba(100, 100, 100, 0.5);
                            border-right: none;
                        }
                    }
                    .right-box {
                        display: block;
                        .submit-btn {
                            border-radius: 0 2px 2px 0;
                            height: 46px;
                            line-height: 46px;
                            font-size: 14px;
                            .iconfont {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
